import { UPDATE } from "../../../Actions/types";
import { UpdateComponent } from "../../../Core/Components/UpdateComponent";
import { RW } from "../../../Helpers/LangHelper";

type langProps = {
    for: string;
    c?:boolean
}

class LangItem extends UpdateComponent {
    props: langProps
    constructor(props: langProps){
        super(props)
        this.type = UPDATE.LANG
        this.props = props
    }
    render() {
        return <>{typeof RW(this.props.for) === "string" ? RW(this.props.for):this.props.for}</>
    }
}

export { LangItem }
